import { Component, Input } from "@angular/core";
import { avatarUserDetailsDto } from "../../../core/models/task-management/avatar-user-details";
import { SkeletonModule } from "primeng/skeleton";
import { CommonModule } from "@angular/common";

@Component({
  selector: "jni-user-avatar-details",
  imports: [SkeletonModule, CommonModule],
  templateUrl: "./user-avatar-details.component.html",
  styleUrl: "./user-avatar-details.component.scss",
})
export class UserAvatarDetailsComponent {
  @Input() userAvatorDetails!: avatarUserDetailsDto;
  @Input() isLoading = false;
}
